<template>
  <div>
    <v-autocomplete
      v-model="itens_selecionados"
      placeholder="Frequências de saídas"
      :items="items"
      multiple
      hide-selected
      outlined
      clearable
      height="10"
      return-object
      hide-details
    >
      <template v-slot:selection>
        <!-- NADA -->
      </template>

      <template v-slot:prepend-inner v-if="itens_selecionados.length > 0">
        <v-chip class="mt-n1 txt-row">
          {{ `${itens_selecionados.length} selecionada${itens_selecionados.length > 1 ? 's' : ''}` }}
        </v-chip>
      </template>

      <template #prepend-item>
        <SysItemListaSelecionaTudo
          v-model="itens_selecionados"
          :itens="items"
        />
        <v-divider />
      </template>
    </v-autocomplete>

    <div id="itens-selecionados">
      <v-list dense>
        <v-subheader>
          {{ itens_selecionados.length > 0 ? 'Frequências de saídas selecionadas' : 'Selecione uma ou mais Frequências de saídas' }}
        </v-subheader>

        <template v-for="(item, index) in itens_selecionados">
          <v-list-item :key="index">
            <v-list-item-action title="Desmacar" class="ml-n3">
              <v-btn icon color="primary" @click="removerItem(item)">
                <v-icon>mdi-checkbox-marked</v-icon>
              </v-btn>
            </v-list-item-action>

            <v-list-item-title v-text="item.text"></v-list-item-title >

            <v-btn icon @click="removerItem(item)" title="Desmacar">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-list-item>

          <v-divider
            v-if="index < itens_selecionados.length - 1"
            :key="`${index}_`"
          ></v-divider>
        </template>
      </v-list>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  }
}
</script>

<script setup>
import {computed, onMounted, ref, watch} from "vue";
import SysItemListaSelecionaTudo from "@/components/utils/crud/SysItemListaSelecionaTudo.vue";
import {arrayColumn} from "@/helpers";

const props = defineProps({
  modelValue: Array,
});

const emit = defineEmits(['update:modelValue']);

const itens_selecionados = ref([]);
watch(itens_selecionados, () => VALOR_COMPUTED.value = arrayColumn(itens_selecionados.value, 'value'));

const VALOR_COMPUTED = computed({
  get: () => props.modelValue,
  set: valor => emit('update:modelValue', valor),
});

onMounted(() => {
  itens_selecionados.value = items;
});

const items = [
  {
    value: 'P',
    text: '1. Frequência Alta de Saída',
  },
  {
    value: 'Q',
    text: '2. Frequência Média de Saída',
  },
  {
    value: 'R',
    text: '3. Frequência Baixa de Saída',
  }
];

function removerItem (item) {
  this.itens_selecionados = this.itens_selecionados.filter(f => f.value !== item.value)
}
</script>

<style scoped>
.txt-row {
  white-space: nowrap
}
#itens-selecionados {
  border-left: 1px solid rgba(0,0,0,.1);
  border-right: 1px solid rgba(0,0,0,.1);
  height: calc(100vh - 135px);
  overflow-y: auto;
}
</style>
